import React, { useEffect, useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";

const KEY = "m2hat_theme_preference";
const ORDER = ["auto", "light", "dark"];
const LABEL = { auto: "Thème : automatique (réglage système)", light: "Thème : clair", dark: "Thème : sombre" };
const ICON = { auto: Monitor, light: Sun, dark: Moon };

const media = () => window.matchMedia("(prefers-color-scheme: dark)");
const readPref = () => { const v = localStorage.getItem(KEY); return ORDER.includes(v) ? v : "auto"; };
const apply = (pref) => {
  const dark = pref === "dark" || (pref === "auto" && media().matches);
  document.documentElement.classList.toggle("dark", dark);
};

// À appeler une fois au démarrage pour éviter le flash de thème.
export const initTheme = () => apply(readPref());

export const ThemeToggle = ({ className = "" }) => {
  const [pref, setPref] = useState(readPref);
  useEffect(() => {
    apply(pref);
    localStorage.setItem(KEY, pref);
    if (pref !== "auto") return undefined;
    const m = media();
    const onChange = () => apply("auto");
    m.addEventListener("change", onChange);
    return () => m.removeEventListener("change", onChange);
  }, [pref]);
  const next = () => setPref((p) => ORDER[(ORDER.indexOf(p) + 1) % ORDER.length]);
  const Icon = ICON[pref];
  return (
    <button onClick={next} title={LABEL[pref]} aria-label={LABEL[pref]} data-testid="theme-toggle" data-theme-pref={pref}
      className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-[var(--border)] bg-[var(--surface)] text-[var(--ink-soft)] text-xs font-semibold hover:text-[var(--ink)] hover:border-[var(--gold)] transition-colors ${className}`}>
      <Icon size={15} /> <span className="hidden sm:inline">{pref === "auto" ? "Auto" : pref === "light" ? "Clair" : "Sombre"}</span>
    </button>
  );
};
